import React, { useState, useEffect, useCallback } from 'react';
import {
	Grid,
	Card,
	CardMedia,
	CardContent,
	Typography,
} from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import BackButton from '../BackButton';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';
import { withRouter } from 'react-router-dom';
import { styles } from './MarketingCampaigns.styles';
import { marketing } from '../../constants/mainViewList';
import { CAMPAIGN_ITEMS, CampaignItem, CAMPAIGN_WITHOUT_PRODUCT_SELECTION } from '../../constants/marketingCampaign';
import { getALLMenus } from '../../apis/backend';
import { handlePromoValidate, getCommonProductsBySection, getAvailableOrderTypes, Menu, Section } from './MarketingCampaigns.promo.services';
import { CampaignModalSkeleton } from './CampaignModalSkeleton';
import { getCampaignDefinition } from './campaigns/registry';

const CampaignPromoComponent: React.FC<any> = ({ classes, history, shops, marketingData, openErrorModal, nbShops, shopId, isAllShops, generalConfig }) => {
	const [selectedCampaign, setSelectedCampaign] = useState<CampaignItem | null>(null);
	const [openModal, setOpenModal] = useState<boolean>(false);
	const [selectedShops, setSelectedShops] = useState<string[]>([]);
	const [allMenus, setAllMenu] = useState<Menu>({});
	const [sections, setSections] = useState<Section[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isMenusLoading, setIsMenusLoading] = useState<boolean>(true);
	const isShopContext = !isAllShops;
	const availableOrderTypes = getAvailableOrderTypes(
		isShopContext && shopId ? [String(shopId)] : [],
		shops || {},
		generalConfig
	);

	const handleCloseModal = useCallback(() => {
		setOpenModal(false);
		setSelectedCampaign(null);
	}, []);

	const openCampaign = useCallback((item: CampaignItem) => {
		setSelectedCampaign(item);
		if (isShopContext) {
			setSelectedShops([String(shopId)]);
		} else {
			setSelectedShops([]);
		}
		setOpenModal(true);
	}, [isShopContext, shopId]);

	useEffect(() => {
		const fetchData = async () => {
			setIsMenusLoading(true);
			try {
				const menus = await getALLMenus();
				setAllMenu(menus);
			} catch (error) {
				console.error('Error fetching menus', error);
			} finally {
				setIsMenusLoading(false);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		const commonSections = getCommonProductsBySection(selectedShops, allMenus);
		setSections(commonSections)
	}, [selectedShops, allMenus]);

	console.log({ availableOrderTypes })
	return (
		<div className="p-4">
			<BackButton
				className="p-0"
				onClick={() => history.goBack()}
				title={marketing.campaignPromo.text}
				subtitle={marketing.campaignPromo.description}
			/>

			<Grid container spacing={2} className="mt-2">
				{CAMPAIGN_ITEMS.map((item) => {
					const disabled = marketingData?.[item.id]?.disabled || false;
					const withoutProductSelection = CAMPAIGN_WITHOUT_PRODUCT_SELECTION.includes((item as CampaignItem).id);

					return (
						<Grid item xs={12} sm={6} md={3} key={item.id}>
							<Card className={classes.card} aria-disabled={disabled} onClick={() =>
								!disabled && openCampaign(item)}>
								{disabled && (
									<div className={classes.disabledItem}>
										<Typography variant="body2" className={`${classes.disabledTypo} px-3`}>
											Pour activer la fonctionnalité, merci de contacter Dishop
										</Typography>
									</div>
								)}

								<CardMedia component="img" src={item.image} alt={item.title} className={classes.media} />

								<CardContent className={classes.campaignCardContent}>
									<Typography variant="subtitle1" className={classes.campaignTitle}>
										{item.title}
									</Typography>
									<Typography variant="body2" className={classes.campaignDescription}>
										{item.description}
									</Typography>
									<Typography variant="body2" className={classes.more} onClick={(e) => {
										e.stopPropagation();
										!disabled && openCampaign(item);
									}}>
										EN SAVOIR PLUS <ChevronRight className={classes.leftArrow} />
									</Typography>
								</CardContent>
							</Card>

							{selectedCampaign?.id === item.id && openModal && (
								<CampaignModalSkeleton
									open={openModal}
									onClose={handleCloseModal}
									definition={getCampaignDefinition(item.id)}
									campaignMeta={item}
									includeRestaurantsStep={!isShopContext}
									shops={shops}
									initialSelectedShopIds={
										isShopContext ? [String(shopId)] : selectedShops
									}
									onSelectedShopIdsChange={setSelectedShops}
									sections={sections}
									allMenus={allMenus}
									openErrorModal={openErrorModal}
									onLaunch={(formValues, shopIdsForSubmit) =>
										handlePromoValidate(
											formValues,
											shopIdsForSubmit,
											setOpenModal,
											() => undefined,
											openErrorModal,
											setIsLoading,
											withoutProductSelection,
											false,
											undefined,
											isAllShops,
											shopId
										)
									}
									loading={isLoading}
									productDataLoading={!withoutProductSelection && isMenusLoading}
									isUpdate={false}
									availableOrderTypes={availableOrderTypes}
								/>
							)}
						</Grid>
					);
				})}
			</Grid>

		</div>
	);
};

function mapStateToProps({ firebaseRealTime, user }) {
	const { shops = {}, generalConfig = {} } = firebaseRealTime
	const { marketing: marketingData } = generalConfig
	const { shopId, nbShops, isAllShops } = user;
	return { shops, marketingData, nbShops, shopId, isAllShops, generalConfig };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(CampaignPromoComponent)));
